import { Alert, Skeleton } from "antd"

export const DataLoadingFeedback = ({
  loading = true,
  error = null,
  errorDescription = "Ocurrió un error al cargar los datos",
  children
}) => {
  if (loading) {
    return <Skeleton active loading={loading} />
  }

  if (error) {
    return (
      <Alert
        type="error"
        message={errorDescription} />
    )
  }

  return children
}
